<template>
  <CCard>
    <CCardHeader>
      <strong>In-App Tournaments Top Banner</strong>
    </CCardHeader>
    <CCardBody>

      <CRow>
        <CCol sm="12">
          <CInput
            label="Top Banner Title"
            placeholder="Enter top banner title"
            v-model="topBanner.title"
          />
          </CCol>
      </CRow>
      <br>
      <CRow v-if="topBanner.image">
        <CCol sm="12" >
          <img :src="img_url" style="width: 300px" />
          <!-- <CButton color="danger" @click="removeImage">Remove Banner</CButton> -->
        </CCol>
      </CRow>
        <CRow v-else>
          <CCol>
             <span>No top banner is set currently</span>
          </CCol>
         
        </CRow>

        <CInputFile
          vertical
          ref="file"
          type="file"
          id="file"
          @change="onImageChange"
        />
        <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
        <label class="text-danger"
          >(Image Size should be  less than 1 MB)</label
        ><br />
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Update Banner
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
const id = window.location.pathname.split("/").pop();
export default {
  name: "TournamentTopBanner",
  data() {
    return {
      topBanner: {},
      img_url: "",
      title: "",
    };
  },
  created() {
    this.getTopBanner();
  },
  methods: {
    getTopBanner() {
      this.$axios
        .get(`${ADMIN_URL}/fetch-tournament-top-banner`)
        .then((response) => {
          console.log(response.data);
          this.topBanner = response.data.data;
          this.img_url =  this.topBanner.image;
          this.title =  this.topBanner.title;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.topBanner.image = file;
      this.img_url = URL.createObjectURL(file);
    },
    // removeImage(e) {
    //   (this.img_url = ""), (this.topBanner.image = "");
    //   this.onSubmit(e);
    // },
    onSubmit(e) {
  e.preventDefault();
  let currentObj = this;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Accept: "application/json",
    },
  };

  let formData = new FormData();
  formData.append("image", this.topBanner.image);
  formData.append("title", this.topBanner.title);
  formData.append("_method", "post");

  this.$axios
    .post(`${ADMIN_URL}/store-tournament-top-banner`, formData, config)
    .then((response) => {
      console.log("Success", response);
      currentObj.success = response.data.success;
      console.log(response.data);
      if (response.data.success) {
        this.$swal("Success", response.data.message, "success");
      } else {
        this.$swal("Error", response.data.message, "error");
      }
    })
    .catch((error) => {
      
      if (error.response && error.response.data && error.response.data.errors) {

        let errorMsg = Object.values(error.response.data.errors)
          .flat()
          .join('\n');  

        this.$swal("Error", errorMsg, "error");
      } else {
        this.$swal("Error", "Failed to upload image", "error");
      }
    });
}

  },
};
</script>

<style scoped>
</style>
